import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfoFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M10 18C7.125 18 4.5 16.5 3.0625 14C1.625 11.5312 1.625 8.5 3.0625 6C4.5 3.53125 7.125 2 10 2C12.8438 2 15.4688 3.53125 16.9062 6C18.3438 8.5 18.3438 11.5312 16.9062 14C15.4688 16.5 12.8438 18 10 18ZM8.75 12.5C8.3125 12.5 8 12.8437 8 13.25C8 13.6875 8.3125 14 8.75 14H11.25C11.6563 14 12 13.6875 12 13.25C12 12.8437 11.6563 12.5 11.25 12.5H11V9.75C11 9.34375 10.6563 9 10.25 9H8.75C8.3125 9 8 9.34375 8 9.75C8 10.1875 8.3125 10.5 8.75 10.5H9.5V12.5H8.75ZM10 6C9.4375 6 9 6.46875 9 7C9 7.5625 9.4375 8 10 8C10.5313 8 11 7.5625 11 7C11 6.46875 10.5312 6 10 6Z"
	})
});
const ForwardRef = forwardRef(SvgInfoFilled);
export default ForwardRef;
